<template>
  <v-dialog v-model="dialog" width="500">
    <v-card v-if="adding != null">
      <v-card-media height="200px" :src="imgUrl()">
        <v-container fill-height fluid>
          <v-layout fill-height>
            <v-flex xs12 align-end flexbox>
              <span class="headline grey--text">{{getDescr()}}</span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-media>
      <v-card-text>
        <v-text-field
          label="Quantità"
          v-model="quantita"
          prepend-icon="add"
          :prepend-icon-cb="quantUp"
          append-icon="remove"
          :append-icon-cb="quantDown"
        ></v-text-field>
        <v-flex class="pt-1" style="max-height: 200px;overflow-y: auto;">
          <v-btn
            @click.native.stop="addVar(r)" 
            :key="i" 
            :outline="r.quant <= 1" 
            :class="{'orange orange--text': r.quant == 1,
                     'orange white--text': r.quant > 1,
                     'grey grey--text': r.quant == 0, 
                     'red red--text': r.quant == -1}" 
            v-for="(r, i) in adding.content.varianti">
              <span v-if="r.extraProps.quantificabile && r.quant > 0">{{r.quant}} X&nbsp;</span> {{getVarDescr(r)}}
              <v-btn @click.native.stop="r.quant = r.quant == 0 ? -1 : 0" v-if="r.extraProps.toglibile && r.quant == 0 || r.extraProps.quantificabile && r.quant > 0" class="varResetBtn" fab>
                <v-icon>remove</v-icon>
              </v-btn>
          </v-btn>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="green--text darken-1" flat="flat" @click.native="close">Annulla</v-btn>
        <v-btn class="green--text darken-1" flat="flat" @click.native="add">Aggiungi</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Dialog per aggiungere un prodotto al carrello
 * @module components/common/AddToCart 
 */
export default {
    name: 'addToCart',
    data () {
      return {
        adding: null,
        quantita: 1
      }
    },
    methods: {
      close () {
        this.quantita = 1
        this.$emit('close', null)
      },
      add () {

        this.adding.content.varianti = this.adding.content.varianti.filter(vari => vari.quant != 0).map(vari => Object.assign( _.pick(vari, ['_id', 'ctvlx', 'prezzo', 'quant']), {descrizione: this.getVarDescr(vari)}))
        
        let rigaOrdine = {
          _id: this.adding._id,
          updatedAt: this.adding.updatedAt,
          quant: parseInt(this.quantita),
          prod: 
            Object.assign(
              _.pick(this.adding.content, [
                '_id', 'ctvlx', 'prezzo', 'varianti', 'updatedAt', 'stampante', 'reparto',
              ]), 
              { descrizione: this.getDescr() }
            )
          }

        this.quantita = 1
        this.$emit('close', rigaOrdine)
      },
      imgUrl () {
        return utils.getImgUrl(this.adding.content.img).replace(/\\/g, '/')
      },
      getDescr () {
        return utils.getMainDesc(this.adding.content)
      },
      getVarDescr (vari) {
        return utils.getMainDesc(vari)
      },
      quantUp () {
        this.quantita += 1
      },
      quantDown () {
        this.quantita = this.quantita-1 || 1
      },
      used (vari) {
        return this.usedVar.includes(vari._id)
      },
      addVar (vari) {
        if(vari.quant == -1)
          vari.quant = 0
        else if(vari.quant == 0)
          vari.quant = 1
        else if(vari.quant > 0 && vari.extraProps.quantificabile)
          vari.quant += 1
        else if(vari.quant > 0 && !vari.extraProps.quantificabile)
          vari.quant = 0
      }
    },
    watch: {
      toAdd (newV) {
        if(newV != null) {
          let nV = utils.clone(newV)

          nV.content.varianti = nV.content.varIngr
            .filter(vi => vi.extraProps.isVariante)
            .map(nVar => Object.assign({}, this.lib.find(pvi => pvi._id == nVar), {quant: 0}))

          this.adding = nV
        }else
          this.adding = null
      }
    },
    computed: {
      dialog: {
        get () {
          return this.toAdd != null
        },
        set () {
          this.$emit('close')
        }
      }
    },
    /** 
     * @prop toAdd {object} - Il prodotto fa aggiungere al carrello
     * @prop maxVar {number} - Numero massimo di varianti
     * @prop lib {array} - ProdVarIngr 
     */
    props: ['toAdd', 'maxVar', 'lib']
}
</script>

<style lang="stylus" scoped>
.varResetBtn{
  width: 30px
  height: 30px
  position: absolute
  top: -16px
  right: -16px
}
</style>


// WEBPACK FOOTER //
// src/components/common/AddToCart.vue